import { Injectable, TemplateRef } from '@angular/core';
import { langHelper } from 'src/app/shared/helpers-and-utilities/language-helper';

@Injectable({ providedIn: 'root' })
export class ToastService {
  toasts: any[] = [];

  constructor(private langHelper: langHelper) {
  }

  show(textOrTpl: string | TemplateRef<any>, options: any = {}) {
    this.toasts.push({ textOrTpl, ...options });
  }

  showSuccess(message: any) {
    this.show(message, { classname: 'bg-success text-light', delay: 4000 });
  }

  /** HTTP error responses: body is usually in `error.error` (same shape as ApiResponse). */
  requestError(error: any | TemplateRef<any>, options: any = {}) {
    if (error instanceof TemplateRef) {
      this.show(error, options);
      return;
    }

    const payload = error?.error;
    const errs = payload?.errors;
    let text: string;

    if (errs != null) {
      if (Array.isArray(errs)) {
        if (this.langHelper.currentLang === 'en') {
          text = errs.filter((e: any) => e != null && String(e).trim() !== '').join(' ') || String(errs[0] ?? '');
        } else {
          text =
            (errs[1] != null && String(errs[1]).trim() !== '' ? String(errs[1]) : null) ??
            (errs[0] != null ? String(errs[0]) : '') ??
            errs.filter((e: any) => e != null && String(e).trim() !== '').join(' ');
        }
      } else if (typeof errs === 'string') {
        text = errs;
      } else {
        text = String(errs);
      }
      if (!text || !String(text).trim()) {
        text = 'Request failed';
      }
    } else {
      text = 'Internal server error occured';
    }

    const isWarning = payload?.errorType === 4;
    this.show(text, {
      ...options,
      classname: isWarning ? (options.classname ?? 'bg-warning text-dark') : 'bg-danger text-light',
      delay: options.delay ?? 4000
    });
  }

  showError(error: any) {
    let errorMessage: string;
    const errs = error?.error?.errors;
    if (errs) {
      if (Array.isArray(errs)) {
        errorMessage =
          this.langHelper.currentLang === 'en'
            ? String(errs[0] ?? errs.join(' '))
            : String((errs[1] != null && String(errs[1]).trim() !== '' ? errs[1] : errs[0]) ?? errs.join(' '));
      } else {
        errorMessage = String(errs);
      }
    } else {
      errorMessage =
        this.langHelper.currentLang === 'en'
          ? 'An internal server error occured'
          : 'عطل فنى فى السيرفر';
    }
    this.show(errorMessage, { classname: 'bg-danger text-light', delay: 4000 });
  }

  showDangerMessage(message: any) {
    const text =
      message == null || String(message).trim() === '' ? 'An error occurred' : String(message);
    this.show(text, { classname: 'bg-danger text-light', delay: 4000 });
  }
  showInfoMessage(message: any) {
    // console.log(message);
    // this.langHelper.currentLang == 'en' ? errorMessage = message.en : errorMessage = message.ar;
    // this.toasts = [];
    this.show(message, { classname: 'bg-info text-light', delay: 4000 });
  }
  showSuccessMessage(message: any) {
    // console.log(message);
    // this.langHelper.currentLang == 'en' ? errorMessage = message.en : errorMessage = message.ar;
    // this.toasts = [];
    this.show(message, { classname: 'bg-success text-light', delay: 4000 });
  }
  //Exception error

  remove(toast: any) {
    this.toasts = this.toasts.filter(t => t !== toast);
  }
}